module.exports = __webpack_public_path__ + "static/media/4.da128d72.jpg";